import PassportRecordRequirementHealthcareTable from "./PassportRecordRequirementHealthcareTable";

export default PassportRecordRequirementHealthcareTable;